import { NULLISH_DATE } from './chunk-3YIOW4BW.mjs';
import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/settings/users/initialStates.ts
var ROLE_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  active: true,
  locationId: 0,
  roleId: 0,
  backgroundColor: "",
  textColor: "",
  color: "",
  posName: "",
  defaultModule: "homeModule" /* HOME_MODULE */,
  organizationId: 0,
  name: "",
  locationRoleId: 0,
  superAdmin: false,
  homeScreenPermissions: {
    registerModuleAvailable: true,
    menuModuleAvailable: false,
    settingsModuleAvailable: false,
    managementModuleAvailable: false,
    reportsModuleAvailable: false,
    registerModuleDefault: true,
    menuModuleDefault: false,
    customersModuleDefault: false,
    customersModuleAvailable: false,
    settingsModuleDefault: false,
    managementModuleDefault: false,
    reportsModuleDefault: false,
    requireClockInOnPrompt: false
  },
  endOfDayPermissions: {
    viewShiftSummary: "always" /* ALWAYS */
  },
  registerPermissions: {
    createOrders: false,
    deleteOrders: false,
    modifyItemsSentToKitchen: false,
    editOtherUsersOrders: false,
    transferOrderOwner: false,
    manageTables: false,
    addAnyDiscount: false,
    addCustomDiscount: false,
    reopenClosedOrders: false,
    reprint: false,
    deletePrintJobs: false,
    viewPrinterCenter: false,
    changePrinterStatus: false,
    transferPrintJobs: false,
    reAssignBackupPrinter: false,
    reprintClosedCheck: false,
    reprintReceipt: false,
    printEndOfShiftReportOnClockOut: true,
    overrideLicenseEditingId: false,
    editItemPrice: false,
    allow86: true,
    // TODO - check for default value
    showMenuSelector: false,
    behaviorOnNewOrder: "enter_order" /* ENTER_ORDER */,
    createChecks: true,
    createPayments: true,
    batch: false,
    manageDrawers: false,
    viewDrawerBalance: false,
    serverBankEnabled: false,
    allowCashPaymentsToDrawersNotAttached: false,
    createOpenItemsOrModItems: true,
    allowNoTaxInclusive: false,
    exemptTax: false,
    manageServiceCharges: false,
    transferPayments: false,
    defaultRegisterScreen: "View Orders" /* VIEW_ORDERS */,
    navigationActionOnSendButton: "View Tables" /* VIEW_TABLES */,
    navigationActionOnDoneButton: "Logout" /* LOGOUT */,
    navigationActionOnSendStayButton: "Stay In Order" /* STAY_IN_ORDER */,
    navigationActionOnCloseOrder: "View Tables" /* VIEW_TABLES */,
    navigationActionOnTipPending: "Stay In Order" /* STAY_IN_ORDER */,
    qsrActionOnPay: "view orders" /* VIEW_ORDERS */,
    navigationActionOnFire: "None" /* NONE */,
    navigationActionOnPrintChecks: "None" /* NONE */,
    defaultOrderType: "dine in" /* DINE_IN */,
    autoFilterTableTabsOrders: false,
    // TODO - check for default value
    voidIndividualItems: true,
    sendIndividualItems: true,
    makeHouseChargePayments: true,
    makeGiftCardPayments: true,
    voidRefundPayments: false,
    refundTypeRefund: false,
    refundTypeAsDiscount: false,
    refundTypeToBalanceDueOfZero: false,
    refundTypeReplacePayment: false,
    cashPaymentOptions: null
  },
  menuPermissions: {
    accessMasterMenu: false,
    massUpdate: false
  },
  settingsPermissions: {
    accessMasterSettings: false
  },
  dashboardIds: [],
  defaultDashboardId: null
});
var SHIFT_TIME_SUMMARY_INITIAL_STATE = {
  status: "inactive",
  clockInTime: NULLISH_DATE,
  breakInTime: NULLISH_DATE,
  lastClockInTime: NULLISH_DATE,
  lastClockOutTime: NULLISH_DATE,
  cumulativeBreakTime: 0,
  role: ROLE_INITIAL_STATE,
  lastClockedInRole: ROLE_INITIAL_STATE,
  drawers: {}
};
var USER_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  user: __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    phoneNumber: "",
    isUserVerifiedToTableTurn: false
  }),
  organizationUserId: 0,
  userId: 0,
  active: true,
  webPortalAccess: true,
  posName: "",
  payrollId: "",
  pin: "",
  userType: "",
  roleIds: [],
  shiftTimeSummary: SHIFT_TIME_SUMMARY_INITIAL_STATE,
  loggedInRole: ROLE_INITIAL_STATE,
  menuAccessLocations: [],
  settingsAccessLocations: [],
  recentOrders: [],
  locationIds: [],
  isUserVerifiedToOrg: false,
  individualTipBank: 0,
  allocatedTipBank: 0
});

export { ROLE_INITIAL_STATE, USER_INITIAL_STATE };
